import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './full-image-video.scss.js';
import { AlignmentTypes } from './types.js';

class FullImageVideo extends s {
    constructor() {
        super();
        this.isWithAlert = false;
        this._isMobile = false;
        this.bodyContainer = null;
        this.componentContainer = null;
        this.ctaContainer = null;
        this.heroHeight = 0;
        this.heroMinHeight = 0;
        this.screenWidth = 0;
        this.titleContainer = null;
        this.videoContainer = null;
        this.videoTumbnail = null;
        this.firstUpdated = () => {
            this.getScreenWidth();
            this.setMobile();
            this.getMainElements();
            this.getMinHeight();
            this.getHeroHeight();
            this.setHeroHeight();
            this.setDistribution();
            this.handleCtaStyles();
        };
        this._query = '(max-width: 767px)';
        this.updateScreenWidthHandler = this.updateScreenWidth.bind(this);
    }
    getScreenWidth() {
        this.screenWidth = window.innerWidth;
    }
    changeLightToDark(className, element) {
        if (className.includes('light') && this._isMobile) {
            const newClassName = className.replace('light', 'dark');
            element === null || element === void 0 ? void 0 : element.classList.remove(className);
            element === null || element === void 0 ? void 0 : element.classList.add(newClassName);
            this.requestUpdate();
        }
        else if (className.includes('dark') && !this._isMobile) {
            const newClassName = className.replace('dark', 'light');
            element === null || element === void 0 ? void 0 : element.classList.remove(className);
            element === null || element === void 0 ? void 0 : element.classList.add(newClassName);
            this.requestUpdate();
        }
    }
    setMobile() {
        if (this.screenWidth < 1024) {
            this._isMobile = true;
            this.requestUpdate();
        }
        else {
            this._isMobile = false;
            this.requestUpdate();
        }
    }
    getMainElements() {
        this.videoContainer = this.shadowRoot.querySelector('.video-container');
        this.videoTumbnail = this.shadowRoot.querySelector('.video-thumbnail');
        this.titleContainer = this.shadowRoot.querySelector('.title-container');
        this.bodyContainer = this.shadowRoot.querySelector('.body-container');
        this.ctaContainer = this.shadowRoot.querySelector('.cta-container');
        this.componentContainer =
            this.shadowRoot.querySelector('.full-image-video');
    }
    getMinHeight() {
        this.heroMinHeight = 410;
        if (!this.videoContainer)
            return;
        this.videoContainer.style.height = `${this.heroMinHeight}px`;
    }
    getHeroHeight() {
        this.heroHeight = this.heroMinHeight;
    }
    setHeroHeight() {
        if (!this.videoContainer ||
            !this.componentContainer ||
            !this.videoTumbnail ||
            !this.bodyContainer ||
            !this.ctaContainer) {
            return;
        }
        if (this._isMobile) {
            this.videoContainer.style.height = `${this.heroHeight}px`;
            this.videoTumbnail.style.height = `${this.heroHeight}px`;
            this.componentContainer.style.height = `${this.videoContainer.offsetHeight +
                this.bodyContainer.offsetHeight +
                this.ctaContainer.offsetHeight}px`;
        }
        else {
            this.videoContainer.style.height = `${this.heroHeight}px`;
            this.videoTumbnail.style.height = `${this.heroHeight}px`;
            this.componentContainer.style.height = `${this.heroHeight}px`;
        }
    }
    setDistribution() {
        if (!this.titleContainer ||
            !this.bodyContainer ||
            !this.ctaContainer ||
            !this.componentContainer) {
            return;
        }
        if (this._isMobile) {
            this.titleContainer.style.bottom = `0px`;
            this.requestUpdate();
        }
        else {
            this.bodyContainer.style.top = `${this.titleContainer.offsetHeight}px`;
            this.ctaContainer.style.top = `${this.titleContainer.offsetHeight + this.bodyContainer.offsetHeight}px`;
            this.requestUpdate();
        }
    }
    handleCtaStyles() {
        const ctaAll = this.querySelectorAll('generic-button');
        ctaAll.forEach(ctaComponent => {
            const link = ctaComponent.querySelector('a');
            const button = ctaComponent.querySelector('button');
            const linkStyles = link === null || link === void 0 ? void 0 : link.classList;
            const buttonStyles = button === null || button === void 0 ? void 0 : button.classList;
            linkStyles === null || linkStyles === void 0 ? void 0 : linkStyles.forEach(className => {
                this.changeLightToDark(className, link);
            });
            buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.forEach(className => {
                this.changeLightToDark(className, button);
            });
        });
        this.requestUpdate();
    }
    updateScreenWidth() {
        this.screenWidth = window.innerWidth;
        this.setMobile();
        this.getMainElements();
        this.getMinHeight();
        this.getHeroHeight();
        this.setHeroHeight();
        this.setDistribution();
        this.handleCtaStyles();
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        const alertBanner = document.querySelector('alert-banner');
        if (alertBanner) {
            this.isWithAlert = true;
        }
        window.addEventListener('resize', this.updateScreenWidthHandler);
        this.updateScreenWidth();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('resize', this.updateScreenWidthHandler);
    }
    renderVideoSlot() {
        return !this._isMobile ? x `<slot name="video"></slot>` : null;
    }
    render() {
        return x `<lit-media-query .query="${this._query}" @changed="${this._handleMediaQuery}"></lit-media-query><div dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}" class="full-image-video ${o({
            rtl: this.rtl || isRTL(),
            left: this.alignment === AlignmentTypes.LEFT,
            right: this.alignment === AlignmentTypes.RIGHT,
        })}"><div class="fixed-content"><div class="video-container"><div class="title-container"><slot name="heading"></slot></div><div class="video-thumbnail"><div class="gradient"></div><div class="iframe-container">${this.renderVideoSlot()}</div><slot name="background-img" class="background-img"></slot></div></div><div class="body-container"><slot name="body-text"></slot></div><div class="cta-container"><slot name="video-cta"></slot><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div></div>`;
    }
    _handleMediaQuery(event) {
        this._isMobile = event.detail.value;
        this.requestUpdate();
    }
}
FullImageVideo.styles = css_248z;
__decorate([
    n()
], FullImageVideo.prototype, "alignment", void 0);
__decorate([
    n({ type: Boolean })
], FullImageVideo.prototype, "autoplay", void 0);
__decorate([
    n({ type: Boolean })
], FullImageVideo.prototype, "rtl", void 0);
__decorate([
    t()
], FullImageVideo.prototype, "isWithAlert", void 0);
customElements.define('full-image-video', FullImageVideo);

export { FullImageVideo };
